import React from "react";
import styled from "styled-components";
import { IoIosLock } from "react-icons/io";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

const InputWrapper = styled.div`
  display: flex;

  align-items: center;
  border: 1px solid var(--tertiary-font-color);
  padding: 4px;
  border-radius: 5px;
  gap: 8px;
  //  width: 100%; /* Ensures wrapper takes full width */
  input,
  textarea,
  select {
    border: none;
    outline: none;
    font-size: 1rem;
    background: transparent;
    color: var(--secondary-font-color);
    width: 100%; /* Makes sure both input & textarea take full width */
    flex: 1; /* Helps maintain equal width inside flex container */
  }

  textarea {
    resize: vertical;
    min-height: 120px; /* Taller than inputs */
  }

  svg {
    color: var(--secondary-font-color);
    font-size: 1.2rem;
  }
`;

const Button = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export interface InputFieldProps {
  placeholder?: string;
  icon?: React.ReactNode;
  type?: string;
  value: string;
  isRequired?: boolean;
  label?: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  height?: string;
  name: string;
  readonly?: boolean;
}

const InputField: React.FC<InputFieldProps> = ({
  placeholder,
  icon,
  type,
  value,
  label,
  isRequired,
  onChange,
  height,
  name,
  readonly,
}) => {
  return (
    <Wrapper>
      {label && (
        <div style={{ paddingBottom: "6px" }}>
          {isRequired && "*"}
          {label}
        </div>
      )}
      <InputWrapper
        style={{ backgroundColor: readonly ? "#a8a7a745" : "transparent" }}
      >
        {type === "textarea" ? (
          <textarea
            name={name}
            value={value}
            onChange={onChange}
            required={isRequired}
            placeholder={placeholder}
            style={{ height: height ?? "120px" }} // Default larger height
          />
        ) : (
          <>
            {icon && <Button>{icon}</Button>}
            {readonly && <IoIosLock />}
            <input
              name={name}
              onChange={onChange}
              value={value}
              style={{ height: height ?? "auto" }}
              required={isRequired}
              type={type ?? "text"}
              placeholder={placeholder}
              readOnly={readonly}
            />
          </>
        )}
      </InputWrapper>
    </Wrapper>
  );
};

export default InputField;
